<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="diaVisible"
    @close="$emit('update:visible', false)"
    bodyHeight="235px"
    class="category-list-modal"
    title
    width="500px"
  >
    <div slot="title" style="font-weight:bold">
      {{
        params.type == 'add'
          ? $t('after-sales::after-sales-set::add_reason')
          : params.type == 'next'
          ? $t('after-sales::after-sales-set::add_reason_add_sub')
          : $t('after-sales::after-sales-set::add_reason_add_edit')
      }}
    </div>
    <el-form :model="params" :rules="rules" class="cate-body" label-width="100px" ref="form" v-loading="cateloading">
      <el-form-item
        :label="$t('after-sales::after-sales-set::add_reason_parent_cate')"
        prop="category"
        v-if="((params.type == 'edit' && params.row && params.row.parentId !== 0) || params.type === 'add') && visible"
      >
        <el-cascader
          :disabled="params.type !== 'add' && params.row && params.row.childrens && params.row.childrens.length !== 0"
          :options="tableData"
          :props="props"
          @change="handleCase"
          class="input-item"
          clearable
          filterable
          ref="casc"
          v-model="params.category"
        ></el-cascader>
      </el-form-item>
      <el-form-item :label="$t('after-sales::after-sales-set::add_reason_parent_cate')" v-if="params.type == 'next'">
        <span>{{ parentCate ? parentCate : '/' }}</span>
      </el-form-item>
      <el-form-item :label="$t('after-sales::after-sales-set::add_responsible_party')" prop="dutyId">
        <el-select
          :placeholder="$t('after-sales::after-sales-set::add_responsible_party_holder')"
          class="input-item"
          v-model="params.dutyId"
        >
          <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in dutyIds"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('after-sales::after-sales-set::add_reason_type')" prop="name">
        <el-input class="input-item" maxlength="20" v-model.trim="params.name"></el-input>
      </el-form-item>
    </el-form>

    <div class="dialog-footer" slot="footer" style="text-align:center">
      <el-button size="small" @click="$emit('update:visible', false)">
        {{ $t('after-sales::after-sales-set::add_cancel') }}
      </el-button>
      <el-button size="small" :loading="loading" @click="onSave" type="primary">
        {{ $t('after-sales::after-sales-set::add_save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { putMerchantConfigUpdate, putMerchantConfig, getDicByCode } from '@/server/common'
export default {
  name: 'category-list-modal',
  props: {
    visible: {
      default: true
    },
    cateData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    visible(bool) {
      this.diaVisible = bool
      if (bool) {
      } else {
        this.$refs.form.resetFields()
      }
    },
    cateData(data) {
      for (let i in data) {
        this.$set(this.params, i, data[i])
      }
      if (data.type === 'add') {
        this.params.row = null
        this.params.category = []
        this.params.color = ''
      }
      this.getListData()
      this.getListDataDuty()
      if (data.type === 'next') {
        if (data.rowParent) {
          this.parentCate = data.rowParent.name + '/'
          const fAr = (arr, tarr = []) => {
            arr.forEach(item => {
              if (item.childrens.length) {
                tarr = tarr.concat(fAr(item.childrens))
              }
            })
            return tarr.concat(arr)
          }
          let arrAll = fAr([data.rowParent], [])
          data.row.category.split('-').forEach((id, i) => {
            if (i > 0) {
              this.parentCate += arrAll.find(item => Number(id) === item.id).name + '/'
            }
          })
        }
      }
      this.$nextTick(() => this.$refs.form.clearValidate())
    }
  },
  mounted() {},
  data() {
    return {
      props: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'childrens',
        leaf: 'level'
      },
      parentCate: '',
      tableData: [],
      dutyIds: [],
      diaVisible: false,
      cateloading: false,
      loading: false,
      rules: {
        name: [{ required: true, message: $t('after-sales::email-setting::please_inpu_after'), trigger: 'change' }],
        dutyId: [{ required: true, message: $t('after-sales::email-setting::please_select_duty'), trigger: 'change' }],
        category: [
          {
            required: true,
            message: $t('after-sales::email-setting::please_input_cate'),
            type: 'array',
            trigger: 'change'
          }
        ]
      },
      params: {
        dutyId: '',
        parentId: [],
        category: []
      },
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0
      },
      list: []
    }
  },
  computed: {
    childCheck() {
      return this.params.row && this.params.row.childrens.length
    }
  },
  methods: {
    async getListData() {
      this.cateloading = true
      const { data } = await putMerchantConfig(1, {})
      this.cateloading = false
      if (data.code === this.$code) {
        this.tableData = data.data.map((item, i) => {
          if (item.childrens.length) {
            item.childrens = this.reverseData(item, [])
          } else {
            if (item.childrens) delete item.childrens
          }

          return {
            ...item
          }
        })
        if (this.params.type === 'add' || !this.childCheck) {
          this.tableData.unshift({
            id: 0,
            level: 0,
            category: '',
            parentId: 0,
            parentName: null,
            name: '/'
          })
        }
      }
    },
    async getListDataDuty() {
      this.cateloading = true
      const { data } = await getDicByCode(4)
      this.cateloading = false
      if (data.code === this.$code) {
        this.dutyIds = data.data.map((item, i) => {
          return {
            ...item,
            name: this.$t(`system::responsible::${item.name}`, item.name)
          }
        })
      }
    },

    reverseData(data, arr = []) {
      return data.childrens.map(item => {
        if (item.childrens && item.childrens.length) {
          arr.push(data.id)
          item.childrens = this.reverseData(item, JSON.parse(JSON.stringify(arr)))
          return {
            parentIds: arr,
            ...item
          }
        } else {
          arr.push(data.id)
          if (item.childrens) delete item.childrens
          return {
            parentIds: arr,
            ...item
          }
        }
      })
    },
    handleCase(val) {
      console.log(val)
    },
    onSave() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.loading = true
          // const childCheck = this.params.row && this.params.row.childrens.length
          const params = {
            type: 1,
            parentId:
              this.params.type === 'next'
                ? this.params.row.id
                : this.childCheck
                ? this.params.row.parentId
                : this.params.category[this.params.category.length - 1],
            category:
              this.params.type === 'add'
                ? this.params.category.includes(0)
                  ? null
                  : this.params.category.join('-')
                : this.childCheck
                ? this.params.row.category
                : this.params.category && this.params.category.join('-'),
            name: this.params.name,
            level:
              this.params.type === 'next'
                ? Number(this.params.row.level + 1)
                : this.childCheck
                ? this.params.row.level
                : this.params.category.includes(0)
                ? 0
                : this.params.category.length
          }
          let res = null
          if (this.params.type === 'add') {
            params.dutyId = this.params.dutyId
            res = await putMerchantConfigUpdate(params)
          } else if (this.params.type === 'edit' || this.params.type === 'next') {
            if (this.params.type === 'edit') {
              if (this.childCheck) {
                delete params.category
                delete params.parentId
                delete params.level
              }
              params.id = this.params.id
            }
            params.dutyId = this.params.dutyId

            res = await putMerchantConfigUpdate(params)
          }
          if (res.data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.$emit('save', this.$deepClone(this.params))
            this.$emit('update:visible', false)
          }
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.category-list-modal {
  .input-item {
    width: 340px;
  }
}
</style>
